import reduxModule from "./redux";
import { useAdvertisement } from "./hook";

export { useAdvertisement };

export default reduxModule;
